import React, { useContext, useEffect, useState } from 'react';
import { EndGameActions, SocketEmit, SoundType } from '../../../types.ds';
import { StyledBtnWithSound } from '../../../sounds/StyledBtnWithSound';
import { ButtonsWrapper, Form, LostMsg, WonMsg } from '../ModalsManager.styled';
import { game } from '../../../store/game';
import { PlayerContext } from '../../../contexts/playerContext';

export const GameEndForm: React.FC = () => {
  const playerContext = useContext(PlayerContext);
  const [result, setResult] = useState<boolean>(false);
  const [tie, setTie] = useState<boolean>(false);
  const [showResult, setShowResult] = useState<boolean>(false);

  const handleEndGame =
    (action: EndGameActions) => (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      game.emit[SocketEmit.EndGame](action);
      game.modalUpdate(true);
      setShowResult(false);
      playerContext?.initialTokenBalanceHandler(playerContext.tokenBalance);
    };

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  useEffect(() => {
    let count = 0;
    if (playerContext && game.player?.balance) {
      const gameResult =
        playerContext.tokenBalance > playerContext.initialTokenBalance
          ? true
          : false;
      setResult(gameResult);

      const gameTied =
        playerContext.tokenBalance === playerContext.initialTokenBalance &&
          game.player.handTotal < 22
          ? true
          : false;
      setTie(gameTied);
      setShowResult(true);
    }
  }, [playerContext?.tokenBalance]);

  return (
    <Form onSubmit={handleFormSubmit}>
      <ButtonsWrapper>
        <StyledBtnWithSound
          soundType={SoundType.Chip}
          onClick={handleEndGame(EndGameActions.Rebet)}
        >
          rebet
        </StyledBtnWithSound>
      </ButtonsWrapper>
      <ButtonsWrapper>
        <StyledBtnWithSound
          soundType={SoundType.Click}
          onClick={handleEndGame(EndGameActions.NewBet)}
        >
          close
        </StyledBtnWithSound>
      </ButtonsWrapper>
      {showResult && result && <WonMsg>You won. ✅</WonMsg>}
      {showResult && !result && !tie && <LostMsg> You lost. ❌</LostMsg>}
      {showResult && tie && <WonMsg>It's a tie. 🟰</WonMsg>}
    </Form>
  );
};
